import { currencyImgPath, eCurrencies } from "app/common/ui/info-icon/info-icon.interface"
import { ICurrencyItem } from "./balances-item-interface"
import { eCompanyItems } from "app/services/companyItems/company-items.interface"

//Settings for ingame Items, it's not the order or the list that will be visible
/* export const INGAME_ITEMS = (): Map<eCompanyItems, IIngameItem> => {
    return new Map<eCompanyItems, IIngameItem>([
        [
            eCompanyItems.LOOTBOX_BASIC, {
                type: eCompanyItems.LOOTBOX_BASIC,
                balance: 0,
                id: '0x4c4f4f54424f585f424153494300000000000000000000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.LOOTBOX_BASIC],
                label: "lootbox bronze"
            }
        ],
        [
            eCompanyItems.LOOTBOX_MEDIUM, {
                type: eCompanyItems.LOOTBOX_MEDIUM,
                balance: 0,
                id: '0x4c4f4f54424f585f4d454449554d000000000000000000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.LOOTBOX_MEDIUM],
                label: "lootbox silver"
            }
        ],
        [
            eCompanyItems.LOOTBOX_PREMIUM, {
                type: eCompanyItems.LOOTBOX_PREMIUM,
                balance: 0,
                id: '0x4c4f4f54424f585f5052454d49554d0000000000000000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.LOOTBOX_PREMIUM],
                label: "lootbox gold"
            }
        ],
        [
            eCompanyItems.UNFREEZE_POTION, {
                type: eCompanyItems.UNFREEZE_POTION,
                balance: 0,
                id: '0x554e465245455a455f504f54494f4e0000000000000000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.UNFREEZE_POTION],
                label: "unfreeze potion"
            }
        ],
        [
            eCompanyItems.DIAMOND_STORY_CHEST, {
                type: eCompanyItems.DIAMOND_STORY_CHEST,
                balance: 0,
                id: '0x4449414d4f4e445f53544f52595f434845535400000000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.DIAMOND_STORY_CHEST],
                label: "lootbox diamond"
            }
        ],
        [
            eCompanyItems.BATTLE_STAMINA_POTION, {
                type: eCompanyItems.BATTLE_STAMINA_POTION,
                balance: 0,
                id: '0x424154544c455f5354414d494e415f504f54494f4e0000000000000000000000',
                image: companyItemImgPath()[eCompanyItems.BATTLE_STAMINA_POTION],
                label: "battle stamina potion"
            }
        ]
    ])
} */

//Settings for currency items, it's not the order or the list that will be visible
export const CURRENCY_ITEM = (): Map<Partial<eCurrencies>, ICurrencyItem> => {
    return new Map<eCurrencies, ICurrencyItem>([
        [
            eCurrencies.KMON, {
                balance: 0,
                currency: "KMON",
                image: currencyImgPath()[eCurrencies.KMON]
            }
        ],
        [
            eCurrencies.BNB, {
                balance: 0,
                currency: "MATIC",
                image: currencyImgPath()[eCurrencies.BNB]
            }
        ],
        [
            eCurrencies.POINTS, {
                balance: 0,
                currency: "Points",
                image: currencyImgPath()[eCurrencies.POINTS]
            }
        ],
        [
            eCurrencies.CANDIES, {
                balance: 0,
                currency: "Candies",
                image: currencyImgPath()[eCurrencies.CANDIES]
            }
        ]
    ])
}